module.exports = __webpack_public_path__ + "static/media/withdrawal_ya.329bd355.svg";